export type EntityStatus = 'active' | 'suspended' | 'deleted';
export enum EntityStatusOptions{
  Active = 1,
  Suspended = 2,
  Deleted = 3
}
export type EntityStatusOption = {
  id: EntityStatus;
  key: string;
  name: string;
};

export const entityStatusOptions: EntityStatusOption[] = [
  {
    id: 'active',
    key: 'ENTITY_STATUS_ACTIVE',
    name: 'Active',
  },
  {
    id: 'suspended',
    key: 'ENTITY_STATUS_SUSPENDED',
    name: 'Suspended',
  },
  {
    id: 'deleted',
    key: 'ENTITY_STATUS_DELETED',
    name: 'Deleted',
  },
];
